import { atom } from "jotai";

export const showCanvasTemplateWidgetAtom = atom(false);
showCanvasTemplateWidgetAtom.debugLabel = "showCanvasTemplateWidgetAtom";
